export default __webpack_public_path__ + "static/media/SndLowerUDownTravelUpBump.7122813f.mp3";